/* eslint-disable max-len */
export const DATA_TABLE_PROPS = {
    atId: { type: String, default: "data-table" },
    title: { type: String, default: "" }, // Title of Table.
    grid: { type: Boolean, default: false }, // (v0.17+) Use “grid mode”
    tableData: { type: Array, default: () => [] }, // tableData containing Array of rows to display.
    columns: { type: Array, default: () => [] }, // (Required) Defining each column’s properties.
    defaultColumns: { type: Array, default: () => [] }, // Defining list of columns used in columns settings popover
    rowKey: { type: String, default: "id" }, // (Required) Property name of each row defining a unique data key for the respective rows.
    rowsPerPageOptions: { type: Array, default: () => [10, 20, 30, 50] }, // Array of Numbers representing options for user to select how many rows per page should be shown.
    totalPages: { type: Number, default: 0 }, // Total number of pages,
    styledTable: { type: Boolean, default: false }, // this prop is for tables like tasks
    selection: { type: String, default: "none" }, // Set selection mode. One of ‘single’, ‘multiple’ or (default) ‘none’.
    loading: { type: Boolean, default: false }, // Show a background process is in progress (like fetching data and so on).
    dark: { type: Boolean, default: false }, // When using Table on a dark background.
    dense: { type: Boolean, default: false }, // Dense mode; Connect with $q.screen for responsive behavior
    flat: { type: Boolean, default: false }, // Applies a 'flat' design (no default shadow)
    bordered: { type: Boolean, default: false }, // Applies a default border to the component
    square: { type: Boolean, default: false }, // Removes border-radius so borders are squared
    hideHeader: { type: Boolean, default: false }, // Hide Table header.
    hideBottom: { type: Boolean, default: false }, // Hide table bottom layer regardless of what it has to display
    hidePagination: { type: Boolean, default: false }, // Hide the pagination controls at the bottom
    separator: { type: String, default: "none" }, // Sets separator for rows/columns/cell. One of ‘horizontal’, ‘vertical’, ‘cell’, ‘none’.
    tableStyle: { type: [String, Array, Object] }, // Style for the <table> tag itself.
    tableClass: { type: [String, Array, Object] }, // Classes for the <table> tag itself.
    binaryStateSort: { type: Boolean, default: false }, // (v0.17.11+) By default, sorting a column has 3 states (no sort, ascending, descending). By using this property it only allows 2 states (ascending, descending).
    selectTableRows: { type: Array, default: () => [] }, // select predefined rows when prop => selection === 'single' / selection === 'multiple'
    resetCurrentPage: { type: Boolean, default: false }, // Reset current page when change all table data (no when using pagination)
    sortPreferences: { type: Object, default: () => {} }, // Load table with sort preferences
    noDataTitle: { type: String, default: "" }, // title content (no data to display)
    noDataDescription: { type: String, default: "" }, // description content (no data to display)
    reorderColumns: { type: Boolean, default: false }, // enable reorder columns (in settings)
    showSettings: { type: Boolean, default: false }, // display settings btn
    settingsTitle: { type: String, default: "" }, // Title of settings popover
    removeTableBorder: { type: Boolean, default: false }, // remove table border
    dataModelMode: { type: String, default: "d" }, // type "mode" for Data Model component
    hideHeaderOnNoData: { type: Boolean, default: false }, // hide table header when no data to display
    rowColorSeparator: { type: Boolean, default: false }, // rows different background color (rows: 1,3,5,... / rows: 2,4,6,...)
    loadingStyle: { type: Object, default: () => {} }, // Set loading state custom style (prop 'loading = true')
    noDataDefaultTableHeight: { type: String, default: "42px" }, // tableHeader height when no data
    rowsPerPageLabel: { type: String, default: " " }, // Text to override default rows per page label at bottom of table
    reduseFromTableHeight: { type: String, default: "" },
    setNewCurentPage: { type: Number, default: 1 },
    pagination: { type: Object, default: () => {} }, // reset pagination view (current page, rowsPerPage)
    showPaginationLabel: { type: Boolean, default: false },
    disableRowsSelection: { type: Boolean, default: false }, // disable all checkbox (selection mode),
    noDataBasicTable: { type: Boolean, default: false }, // used for basic tables when empty state
    noDescription: { type: Boolean, default: false },
    tableEmptyState: { type: Boolean, default: true } // use this prop to display empty state, check all the filters applied, and if its any, change prop to false
};

export const SETTINGS_BTNS = [
    {
        name: "dataTable.btnData", type: "dataModel", color: "outline", icon: "add"
    },
    { name: "dataTable.btnCancel", type: "cancel", color: "outline" },
    { name: "dataTable.btnReset", type: "reset", color: "outline" },
    { name: "dataTable.btnConfirm", type: "confirm", color: "primary" }
];

export const TABLE_BTM_BTNS = [
    {
        tooltip: "dataTable.firstPage", type: "firstPage", color: "link", icon: "first_page"
    },
    {
        tooltip: "dataTable.prevPage", type: "prev", color: "link", icon: "chevron_left"
    },
    {
        tooltip: "dataTable.nextPage", type: "next", color: "link", icon: "chevron_right"
    },
    {
        tooltip: "dataTable.lastPage", type: "lastPage", color: "link", icon: "last_page"
    }
];
